// extracted by mini-css-extract-plugin
export default {"main":"Main_main__-Qyed","main__info":"Main_main__info__JQk8k","main__row":"Main_main__row__g5pqz","main__footer":"Main_main__footer__wg84b","table":"Main_table__SGBeg"};